
import { IntroBg } from "./IntroBg"
import { StoryText } from "./StoryText"

export function OurstoryIntro(){
    return (
        <div className="all">
            <IntroBg />
            <StoryText />
        </div>
    )
}